export default __webpack_public_path__ + "static/media/bookMyShow.d625c146.jpg";